// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".items__container[data-v-e8a376be] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.item__container[data-v-e8a376be] {\n  background-color: white;\n  margin: 5px;\n  padding: 4px 8px;\n  border: 1px solid #d6ddd9;\n  border-radius: 20px;\n  margin-left: 0;\n}", ""]);
// Exports
module.exports = exports;
